import { render } from "./modal.vue?vue&type=template&id=daea173c&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=daea173c&scoped=true&lang=css"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/holcimsgeportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daea173c"]])

export default __exports__